import axios from "axios";
import { notifyTokenRefreshed } from "./Refreshfile";
import { tokenRefreshService } from "../services/tokenRefreshService";

// default
console.log('process.env.BASE_URL',process.env.REACT_APP_BASE_URL)
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.defaults.withCredentials = true;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
// content type
// let authUser: any = (localStorage.getItem("authUser"));

// intercepting to capture errors
// axios.interceptors.response.use(
//   function (response: any) {
//     return response.data ? response.data : response;
//   },
//   function (error: any) {
//     console.log('error--',error.response)
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     // let message: any;
//     // switch (error.status) {
//     //   case 500:
//     //     message = "Internal Server Error";
//     //     break;
//     //   case 401:
//     //     message = "Invalid credentials";
//     //     break;
//     //   case 422:
//     //     message = "Invalid credentials";
//     //     break;
//     //   case 404:
//     //     message = "Sorry! the data you are looking for could not be found";
//     //     break;
//     //   default:
//     //     message = error.message || error;
//     // }
//     // return Promise.reject(message);
//     return Promise.reject(error);
//   }
// );

// Subscribe to token refresh events to update axios headers
tokenRefreshService.subscribe((token: string) => {
  setAuthorization(token);
  notifyTokenRefreshed();
});

// Always inject the freshest token from localStorage on every outgoing request.
// This ensures components that fire requests immediately on mount (before the
// axios default header is updated by setAuthorization in the login thunk)
// always send the correct token, not a stale one from a previous session.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// axios.interceptors.response.use(
//   (response) => (response.data ? response.data : response),
//   async (error) => {
//     const originalRequest = error.config;

//     const isTokenError =
//       error.response?.data?.detail?.includes("token") ||
//       error.response?.data?.code === "token_not_valid";

//     if (error.response?.status === 403 && isTokenError && !originalRequest._retry) {
//       originalRequest._retry = true;

//       if (!isRefreshing) {
//         isRefreshing = true;
//         try {
//           const newToken = await refreshTokenSilently();
//           isRefreshing = false;
//           return axios(originalRequest);
//         } catch (refreshError) {
//           isRefreshing = false;
//           return Promise.reject(refreshError);
//         }
//       }

//       return new Promise((resolve) => {
//         addSubscriber((token: string) => {
//           originalRequest.headers["Authorization"] = `Bearer ${token}`;
//           resolve(axios(originalRequest));
//         });
//       });
//     }

//     return Promise.reject(error);
//   }
// );

axios.interceptors.response.use(
  (response) => (response.data ? response.data : response),
  async (error) => {
    const originalRequest = error.config;


    const isTokenError =
      error.response?.data?.detail?.includes("token") ||
      error.response?.data?.code === "token_not_valid";

    // this conditon is for when the excess_token is expire and direct click on logout then go login and if click on other tabs or pages then genrate new token for existing conditon
    const new_rot = window.location.pathname
    // console.log("new_rot--------",new_rot)
    // console.log("new______here",error.response?.status === 403)
    if(error.response?.status === 403 && (new_rot === "/logout")){
      console.log('logout chal pda----11--')
      return Promise.reject(error)
    }
    // This conditon is when backend server is closed or not working
    if(error.message === "Network Error"){
      console.log('Network Error')
      return Promise.reject(error)
    }

    // 401 means the token is completely invalid (wrong algorithm, tampered, etc.)
    // Clear session and force re-login — but skip this for the login endpoint itself,
    // otherwise wrong-password errors cause a silent page reload instead of showing the alert.
    const requestUrl = originalRequest?.url || "";
    const isLoginRequest = requestUrl.includes("login_user");
    if(error.response?.status === 401 && !isLoginRequest){
      console.log('401 Unauthorized — clearing session and redirecting to login')
      localStorage.removeItem("authUser")
      localStorage.removeItem("userole_")
      window.location.href = "/login"
      return Promise.reject(error)
    }

    // THIS ERROR IS OCCURE WHEN BOTH ADMIN PANEL AND ANY OTHER DOMAIN OF THIS PROJECT IS OPEN IN SAME BROWSER
    // if(error.response?.status === 403){
    //   console.log('Network Error---csrf issue.')
    //   return Promise.reject(error)
    // }

    if (error.response?.status === 403 && isTokenError && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Force a real server call — bypass the cooldown cache so a revoked/blacklisted
        // refresh token is detected immediately rather than after the cooldown expires.
        const newToken = await tokenRefreshService.refreshToken(true);
        console.log('✅ [HTTP] Token refreshed, retrying request');

        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;

        try {
          const res = await axios(originalRequest);
          let data = res;
          if (typeof data === 'string') {
            try {
              data = JSON.parse(data);
            } catch (e) {
              console.error("Failed to parse JSON:", e);
            }
          }
          return Promise.resolve(data);
        } catch (retryError: any) {
          // The retry itself failed (e.g. session was revoked — backend still returns 403).
          // The refresh token was valid but the session is dead on the server side.
          console.error('❌ [HTTP] Retry after token refresh failed — forcing logout:', retryError);
          localStorage.removeItem("authUser");
          localStorage.removeItem("userole_");
          window.location.href = "/login";
          return Promise.reject(retryError);
        }
      } catch (refreshError: any) {
        console.error('❌ [HTTP] Token refresh failed:', refreshError);
        // Refresh failed — refresh token is blacklisted or expired, force logout.
        localStorage.removeItem("authUser");
        localStorage.removeItem("userole_");
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common["Authorization"];
  }
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url: any, params: any) => {
    let response: any;

    let paramKeys: any = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  // create = (url: any, data: any) => {
  //   return axios.post(url, data);
  // };
  create = (url: string, data: any, config = {}) => axios.post(url, data, config)
  /**
   * Updates data
   */
  update = (url: any, data: any) => {
    return axios.patch(url, data);
  };

  put = (url: any, data: any) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url: any, config: any) => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };